import React from 'react'
import { Button } from './styles'
import { IconComponent } from '~/assets/icons/component'
import { TimelineTooltip } from '~/components/shared'

interface IProps {
  tooltipText: string
  onClick: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
}

export const ChangeTimelineButton = ({ tooltipText, onClick, disabled }: IProps): JSX.Element => (
  <TimelineTooltip data-testid="maternal-infant-change-timeline-button" description={tooltipText}>
    <Button onClick={onClick} disabled={disabled}>
      <IconComponent name="change" />
    </Button>
  </TimelineTooltip>
)
